export const dataLocal: any = {
    eu: {
        data: [
            {
                title: '4kWh Starter Kit',
                name: 'EcoFlow DELTA Pro 3 + PowerStream Microinverter 800W',
                power: '4kWh/3400W Solar Input/ 4800W Output',
                // desc: 'Pre-order: Shipment starts from November 25 (DELTA Pro 3)',
                desc: '',
                productId: '9494085927255',
                variantId: '48927477334359',
                moreLink: 'https://eu.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48927477334359',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494395085/DP3%2BWN-EU.png',
                subs: [
                    {
                        name: 'EcoFlow DELTA Pro 3 Smart Extra Battery',
                        desc: '4096Wh Capacity / Expandable up to 12kWh',
                        productId: '9488735895895',
                        variantId: '48911149236567',
                    },
                    {
                        name: 'EcoFlow 400W Rigid Solar Panel (2 pieces)',
                        productId: '9488738320727',
                        variantId: '48911154610519',
                    },
                    {
                        name: 'EcoFlow Smart Plug',
                        productId: '8432538026327',
                        variantId: '46928801268055',
                    },
                ],
            },
            {
                title: '8kWh Extended Ease Kit',
                img: 'https://websiteoss.ecoflow.com/upload/image/1724747843980/bl_ps%2BDP3%2BEB_EU.png',
                name: 'EcoFlow DELTA Pro 3 + Extra Battery + PowerStream Microinverter 800W',
                power: '8kWh/3400W Solar Input/ 4800W Output',
                // desc: 'Pre-order: Shipment starts from November 25 (DELTA Pro 3)',
                desc: '',
                productId: '9494085927255',
                variantId: '48927477465431',
                moreLink: 'https://eu.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48927477465431',
                subs: [
                    // {
                    //     name: 'EcoFlow DELTA Pro 3 Smart Extra Battery',
                    //     productId: '9488735895895',
                    //     variantId: '48911149236567',
                    // },
                    {
                        name: 'EcoFlow 400W Rigid Solar Panel (2 pieces)',
                        productId: '9488738320727',
                        variantId: '48911154610519',
                    },
                    {
                        name: 'EcoFlow Smart Plug',
                        productId: '8432538026327',
                        variantId: '46928801268055',
                    },
                ],
            },
            {
                title: '4kWh Home Battery',
                name: 'EcoFlow DELTA Pro 3',
                power: '4kWh/2600W Solar Input/ 4000W Output',
                // desc: 'Pre-order: Shipment starts from November 25 (DELTA Pro 3)',
                desc: '',
                productId: '9488706797911',
                variantId: '48911033270615',
                moreLink: 'https://eu.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48911033270615',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494351270/DP3-EU.png',
                subs: [
                    {
                        name: 'EcoFlow Delta Pro 3 Smart Extra Battery',
                        desc: '4096Wh Capacity / Expandable up to 12kWh',
                        productId: '9488735895895',
                        variantId: '48911149236567',
                    },
                    {
                        name: 'EcoFlow 400W Portable Solar Panel (1 piece)',
                        productId: '9488750870871',
                        variantId: '48911178858839',
                    },
                ],
            },
        ],
    },
    ph: {
        data: [
            {
                title: '4kWh Starter Kit',
                name: 'EcoFlow DELTA Pro 3 + PowerStream Microinverter 800W',
                power: '4kWh/3400W Solar Input/ 4800W Output',
                desc: '',
                productId: '9494085927255',
                variantId: '48927477334359',
                moreLink: 'https://eu.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48927477334359',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494395085/DP3%2BWN-EU.png',
                subs: [
                    {
                        name: 'EcoFlow DELTA Pro 3 Smart Extra Battery',
                        desc: '4096Wh Capacity / Expandable up to 12kWh',
                        productId: '9488735895895',
                        variantId: '48911149236567',
                    },
                    {
                        name: 'EcoFlow 400W Rigid Solar Panel (2 pieces)',
                        productId: '9488738320727',
                        variantId: '48911154610519',
                    },
                    {
                        name: 'EcoFlow Smart Plug',
                        productId: '8432538026327',
                        variantId: '46928801268055',
                    },
                ],
            },
            {
                title: '8kWh Extended Ease Kit',
                img: 'https://websiteoss.ecoflow.com/upload/image/1724747843980/bl_ps%2BDP3%2BEB_EU.png',
                name: 'EcoFlow DELTA Pro 3 + Extra Battery + PowerStream Microinverter 800W',
                power: '8kWh/3400W Solar Input/ 4800W Output',
                // desc: 'Pre-order: Shipment starts from November 25 (DELTA Pro 3)',
                desc: '',
                productId: '9494085927255',
                variantId: '48927477465431',
                moreLink: 'https://eu.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48927477465431',
                subs: [
                    // {
                    //     name: 'EcoFlow DELTA Pro 3 Smart Extra Battery',
                    //     productId: '9488735895895',
                    //     variantId: '48911149236567',
                    // },
                    {
                        name: 'EcoFlow 400W Rigid Solar Panel (2 pieces)',
                        productId: '9488738320727',
                        variantId: '48911154610519',
                    },
                    {
                        name: 'EcoFlow Smart Plug',
                        productId: '8432538026327',
                        variantId: '46928801268055',
                    },
                ],
            },
            {
                title: '4kWh Home Battery',
                name: 'EcoFlow DELTA Pro 3',
                power: '4kWh/2600W Solar Input/ 4000W Output',
                // desc: 'Pre-order: Shipment starts from November 25 (DELTA Pro 3)',
                desc: '',
                productId: '9488706797911',
                variantId: '48911033270615',
                moreLink: 'https://eu.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48911033270615',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494351270/DP3-EU.png',
                subs: [
                    {
                        name: 'EcoFlow Delta Pro 3 Smart Extra Battery',
                        desc: '4096Wh Capacity / Expandable up to 12kWh',
                        productId: '9488735895895',
                        variantId: '48911149236567',
                    },
                    {
                        name: 'EcoFlow 400W Portable Solar Panel (1 piece)',
                        productId: '9488750870871',
                        variantId: '48911178858839',
                    },
                ],
            },
        ],
    },
    de: {
        data: [
            {
                title: '4 kWh Starter Bundle',
                name: 'EcoFlow DELTA Pro 3 + PowerStream Mikro-Wechselrichter 800 W - \n0 % MwSt. (Nur Deutschland)',
                power: '4 kWh/ 3 400 W Solareingang/ 4 800 W Ausgang',
                // desc: 'Vorbestellung: Auslieferung ab 25. November (DELTA Pro 3)',
                desc: '',
                affirmText: 'Zinsfreie Zahlung in 12 Raten',
                productId: '9489715921231',
                variantId: '49449476030799',
                moreLink: 'https://de.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=49449476030799',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494395085/DP3%2BWN-EU.png',
                isBuyInCallback: true,
                subs: [
                    {
                        name: 'EcoFlow DELTA Pro 3 Intelligente Zusatzbatterie - 0 % MwSt. (Nur Deutschland)',
                        desc: '4096 Kapazität / Erweiterbar auf bis zu 12 kWh',
                        productId: '9480253505871',
                        variantId: '49424789438799',
                    },
                    {
                        name: 'EcoFlow 400 W Starres Solarpanel (2 Stück)  - 0 % MwSt. (Nur Deutschland)',
                        productId: '9480253538639',
                        variantId: '49424797761871',
                    },
                    {
                        name: 'EcoFlow Smart Plug',
                        productId: '8518723764559',
                        variantId: '46932361609551',
                    },
                ],
            },
            {
                title: '8 kWh Komfort Bundle',
                name: 'EcoFlow DELTA Pro 3 + Zusatzbatterie + PowerStream Mikro-Wechselrichter 800 W - \n0 % MwSt. (Nur Deutschland)',
                power: '8 kWh/ 3 400 W Solareingang/ 4 800 W Ausgang',
                // desc: 'Vorbestellung: Auslieferung ab 25. November (DELTA Pro 3)',
                desc: '',
                affirmText: 'Zinsfreie Zahlung in 12 Raten',
                img: 'https://websiteoss.ecoflow.com/upload/image/1724848644898/aa22.png',
                productId: '9489715921231',
                variantId: '49449476194639',
                moreLink: 'https://de.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=49449476194639',
                isBuyInCallback: true,
                subs: [
                    // {
                    //     name: 'EcoFlow DELTA Pro 3 Intelligente Zusatzbatterie - 0 % MwSt. (Nur Deutschland)',
                    //     productId: '9480253505871',
                    //     variantId: '49424789438799',
                    // },
                    {
                        name: 'EcoFlow 400 W Starres Solarpanel (2 Stück)  - 0 % MwSt. (Nur Deutschland)',
                        productId: '9480253538639',
                        variantId: '49424797761871',
                    },
                    {
                        name: 'EcoFlow Smart Plug',
                        productId: '8518723764559',
                        variantId: '46932361609551',
                    },
                ],
            },
            {
                title: '4 kWh Heimspeicher',
                name: 'EcoFlow DELTA Pro 3',
                power: '4 kWh/ 2 600 W Solareingang/ 4 000 W Ausgang',
                // desc: 'Vorbestellung: Auslieferung ab 25. November (DELTA Pro 3)',
                desc: '',
                affirmText: 'Zinsfreie Zahlung in 12 Raten',
                productId: '9480253407567',
                variantId: '49424786358607',
                moreLink: 'https://de.ecoflow.com/products/delta-pro-3-portable-power-station?variant=49424786358607',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494351270/DP3-EU.png',
                subs: [
                    {
                        name: 'EcoFlow DELTA Pro 3 Intelligente Zusatzbatterie',
                        desc: '4096 Kapazität / Erweiterbar auf bis zu 12 kWh',
                        productId: '9480253505871',
                        variantId: '49424789406031',
                    },
                    {
                        name: 'EcoFlow 400 W Tragbares Solarpanel (1 Stück)',
                        productId: '9480253571407',
                        variantId: '49424789504335',
                    },
                ],
            },
        ],
    },
    fr: {
        data: [
            {
                title: 'Kit de démarrage 4 kWh',
                name: 'EcoFlow DELTA Pro 3 + Micro-onduleur PowerStream 800 W',
                power: "4 kWh de capacité / 3 400 W de puissance d'entrée / 4 800 W de puissance de sortie",
                // desc: 'Pré-commande : Expédition à partir du 25 novembre (DELTA Pro 3)',
                desc: '',
                productId: '9381910544731',
                variantId: '48824615469403',
                moreLink: 'https://fr.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48824615469403',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494395085/DP3%2BWN-EU.png',
                subs: [
                    {
                        name: 'Batterie supplémentaire intelligente pour EcoFlow DELTA Pro 3',
                        desc: "4096 Wh Capacité / Capacité évolutive jusqu'à 12 kWh",
                        productId: '9375271911771',
                        variantId: '48799612436827',
                    },
                    {
                        name: 'Panneau solaire rigide EcoFlow 400 W (2 pièces)',
                        productId: '9375271977307',
                        variantId: '48799612502363',
                    },
                    {
                        name: 'Prise intelligente EcoFlow',
                        productId: '8440640569691',
                        variantId: '46941451223387',
                    },
                ],
            },
            {
                title: 'Kit confort 8 kWh',
                name: 'EcoFlow DELTA Pro 3 + Batterie supplémentaire + Micro-onduleur PowerStream 800 W',
                power: "8 kWh de capacité / 3 400 W de puissance d'entrée / 4 800 W de puissance de sortie",
                // desc: 'Pré-commande : Expédition à partir du 25 novembre (DELTA Pro 3)',
                desc: '',
                img: 'https://websiteoss.ecoflow.com/upload/image/1724848644898/aa22.png',
                productId: '9381910544731',
                variantId: '48824615600475',
                moreLink: 'https://fr.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48824615600475',
                subs: [
                    // {
                    //     name: 'Batterie supplémentaire intelligente pour EcoFlow DELTA Pro 3',
                    //     productId: '9375271911771',
                    //     variantId: '48799612436827',
                    // },
                    {
                        name: 'Panneau solaire rigide EcoFlow 400 W (2 pièces)',
                        productId: '9375271977307',
                        variantId: '48799612502363',
                    },
                    {
                        name: 'Prise intelligente EcoFlow',
                        productId: '8440640569691',
                        variantId: '46941451223387',
                    },
                ],
            },
            {
                title: 'Batterie domestique 4 kWh',
                name: 'EcoFlow DELTA Pro 3',
                power: "4 kWh de capacité / 3 400 W de puissance d'entrée / 4 000 W de puissance de sortie",
                // desc: 'Pré-commande : Expédition à partir du 25 novembre (DELTA Pro 3)',
                desc: '',
                productId: '9375271846235',
                variantId: '48799611879771',
                moreLink: 'https://fr.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48799611879771',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494351270/DP3-EU.png',
                subs: [
                    {
                        name: 'Batterie supplémentaire intelligente pour EcoFlow DELTA Pro 3',
                        desc: "4096 Wh Capacité / Capacité évolutive jusqu'à 12 kWh",
                        productId: '9375271911771',
                        variantId: '48799612436827',
                    },
                    {
                        name: 'Panneau solaire portable EcoFlow 400 W (1 pièce)',
                        productId: '9375272010075',
                        variantId: '48799612535131',
                    },
                ],
            },
        ],
    },
    it: {
        data: [
            {
                title: 'Starter Kit da 4 kWh',
                name: 'EcoFlow DELTA Pro 3 + Microinverter PowerStream 800 W',
                power: 'Ingresso solare da 4 kWh/3.400 W / uscita da 4.800 W',
                // desc: 'Pre-ordine: Spedizione a partire dal 25 novembre (DELTA Pro 3)',
                desc: '',
                productId: '9669634359645',
                variantId: '52873564193117',
                moreLink: 'https://it.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=52873564193117',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494395085/DP3%2BWN-EU.png',
                subs: [
                    {
                        name: ' Batteria aggiuntiva intelligente EcoFlow DELTA Pro 3',
                        desc: '4096 Wh Capacità / Espandibile fino a 12 kWh',
                        productId: '9646835958109',
                        variantId: '52783179596125',
                    },
                    {
                        name: ' Pannello solare rigido EcoFlow da 400 W (2 pz.)',
                        productId: '9646836056413',
                        variantId: '52783179956573',
                    },
                    {
                        name: ' EcoFlow Smart Plug',
                        productId: '8420723229021',
                        variantId: '48018805915997',
                    },
                ],
            },
            {
                title: 'Ease Kit esteso da 8 kWh',
                name: ' EcoFlow DELTA Pro 3 + Batteria aggiuntiva + Microinverter PowerStream 800 W',
                power: ' Ingresso solare da 8 kWh/3.400 W / uscita da 4.800 W',
                // desc: 'Pre-ordine: Spedizione a partire dal 25 novembre (DELTA Pro 3)',
                desc: '',
                img: 'https://websiteoss.ecoflow.com/upload/image/1724848644898/aa22.png',
                productId: '9669634359645',
                variantId: '52873564356957',
                moreLink: 'https://it.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=52873564356957',
                subs: [
                    // {
                    //     name: 'Batteria aggiuntiva intelligente EcoFlow DELTA Pro 3',
                    //     productId: '9646835958109',
                    //     variantId: '52783179596125',
                    // },
                    {
                        name: ' Pannello solare rigido EcoFlow da 400 W (2 pz.)',
                        productId: '9646836056413',
                        variantId: '52783179956573',
                    },
                    {
                        name: ' EcoFlow Smart Plug',
                        productId: '8420723229021',
                        variantId: '48018805915997',
                    },
                ],
            },
            {
                title: 'Batteria per uso domestico da 4 kWh',
                name: 'EcoFlow DELTA Pro 3',
                power: ' Ingresso solare da 4 kWh/2.600 W / uscita da 4.000 W',
                // desc: 'Pre-ordine: Spedizione a partire dal 25 novembre (DELTA Pro 3)',
                desc: '',
                productId: '9646835597661',
                variantId: '52783177990493',
                moreLink: 'https://it.ecoflow.com/products/delta-pro-3-portable-power-station?variant=52783177990493',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494351270/DP3-EU.png',
                subs: [
                    {
                        name: 'Batteria aggiuntiva intelligente EcoFlow DELTA Pro 3',
                        desc: '4096 Wh Capacità / Espandibile fino a 12 kWh',
                        productId: '9646835958109',
                        variantId: '52783179596125',
                    },
                    {
                        name: 'Pannello solare portatile da 400 W EcoFlow (1 pz.)',
                        productId: '9646836187485',
                        variantId: '52783180448093',
                    },
                ],
            },
        ],
    },
    es: {
        data: [
            {
                title: 'Kit de inicio de 4 kWh',
                name: ' EcoFlow DELTA Pro 3 + Inversor PowerStream 800 W',
                power: '4 kWh/3400 W de entrada solar / 4800 W de salida',
                // desc: 'Pedido anticipado: Envío a partir del 25 de noviembre (DELTA Pro 3)',
                desc: '',
                productId: '9381919031643',
                variantId: '48824658723163',
                moreLink: 'https://es.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48824658723163',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494395085/DP3%2BWN-EU.png',
                subs: [
                    {
                        name: 'Batería adicional inteligente EcoFlow DELTA Pro 3',
                        desc: '4096 Wh Capacidad / Ampliable hasta 12 kWh',
                        productId: '9375313068379',
                        variantId: '48799731745115',
                    },
                    {
                        name: 'Panel solar rígido de 400 W EcoFlow (2 unidades)',
                        productId: '9375313133915',
                        variantId: '48799731810651',
                    },
                    {
                        name: ' Enchufe inteligente EcoFlow',
                        productId: '8440638865755',
                        variantId: '46941488644443',
                    },
                ],
            },
            {
                title: 'Kit sencillo para ampliar a 8 kWh',
                name: ' EcoFlow DELTA Pro 3 + Batería adicional + Inversor PowerStream 800 W',
                power: ' 8 kWh/3400 W de entrada solar / 4800 W de salida',
                // desc: 'Pedido anticipado: Envío a partir del 25 de noviembre (DELTA Pro 3)',
                desc: '',
                img: 'https://websiteoss.ecoflow.com/upload/image/1724848644898/aa22.png',
                productId: '9381919031643',
                variantId: '48824658854235',
                moreLink: 'https://es.ecoflow.com/products/delta-pro-3-solar-home-battery-system?variant=48824658854235',
                subs: [
                    {
                        name: 'Batería adicional inteligente EcoFlow DELTA Pro 3',
                        productId: '9375313068379',
                        variantId: '48799731745115',
                    },
                    // {
                    //     name: ' Panel solar rígido de 400 W EcoFlow (2 unidades)',
                    //     productId: '9375313133915',
                    //     variantId: '48799731810651',
                    // },
                    {
                        name: ' Enchufe inteligente EcoFlow',
                        productId: '8440638865755',
                        variantId: '46941488644443',
                    },
                ],
            },
            {
                title: 'Batería para el hogar de 4 kWh',
                name: 'EcoFlow DELTA Pro 3',
                power: '4 kWh / 2600 W de entrada solar / 4000 W de salida',
                // desc: 'Pedido anticipado: Envío a partir del 25 de noviembre (DELTA Pro 3)',
                desc: '',
                productId: '9375312970075',
                variantId: '48799731024219',
                moreLink: 'https://es.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48799731024219',
                img: 'https://websiteoss.ecoflow.com/upload/image/1729494351270/DP3-EU.png',
                subs: [
                    {
                        name: 'Batería adicional inteligente EcoFlow DELTA Pro 3',
                        desc: '4096 Wh Capacidad / Ampliable hasta 12 kWh',
                        productId: '9375313068379',
                        variantId: '48799731745115',
                    },
                    {
                        name: 'Panel Solar Portátil EcoFlow de 400 W (1 unidad)',
                        productId: '9375313166683',
                        variantId: '48799733219675',
                    },
                ],
            },
        ],
    },
};
